/*
Ravi 10/10/2022  2692973421  GHI-322/AddedTotalBalance
akhila 11/11/2022 2692973421 removed title from the table
Sai Maheshwar 11/12/2022 3031689933  integrated locked process for advance search table
Gummala Prakash 11/17/2022 3031593925 Removed Toolbar and Search.
Ashraf 12/26/2022 3031593925 fixed client code issues
Sohel 03/21/2023 2700520533 initial Value Changes
Dilip 03/24/2023 2700520533 changed table response
Guru Prasad 06/23/1013 3031593925 Added Locked user name in the toast message
Guru Prasad 06/23/1013 3031593925 Changed toast message
Dilip-pds 09/27/2023 5155351118 Changed field name of total balance
Dilip-pds 09/28/2023 5155351118 Changed field name of phone number
uday 10/02/2023 5155351118 add scroll for table
*/
import React, { useEffect, useState, useContext } from 'react';
// import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid';
import { TablePagination } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import Avatar from 'react-avatar';
import NumberFormat from 'react-number-format';
import { httpPaginationPost } from '../../util/Rest';
import { ACCOUNTSUMMARY } from '../../constants/MicroServiceConstants';
import { tableIcons } from '../../components/TableIcons';
import moment from 'moment';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import { useSelector, useDispatch } from 'react-redux';
import formatSsnNumber from '../../util/SsnFormat';
import formatPhoneNumber from '../../util/PhoneFormat';
import PageLoader from '../../components/PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../../components/CustomSnackBar';
import { defaultRows, tablePageRows } from '../../constants/ReusableTablePagination';
import GuiTable from '../../components/FormComponents/GuiTable';
import { fetchAccountSummary, resetLockAccountStatus } from '../../redux/reducers/AccountSummary';
import { useRef } from 'react';
const useStyles = makeStyles((theme) => ({
  link: {
    color: '#5351fb !important',
  },
  resultSearch: {
    fontSize: '16px !important',
    paddingLeft: '5px',
    fontWeight: '900',
    color: '#000000',
  },
}));

export default function DashboardTable({
  setClear,
  clear,
  submit,
  setSubmit,
  setSearchResults,
  advancedSearchData,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const tableRef = useRef();
  const history = useHistory();
  const [arrayLast, setArrayLast] = useState(false);
  const [loading, setLoading] = useState();
  const [rows, setRows] = useState(defaultRows);
  const colorCodes = ['#DCEDC8', '#C9EDF1', '#FFF9C4', '#FFFDE7', '#FBE9E7'];
  const { errorMsg, successMsg } = useSelector(({ search }) => search);
  const {
    lockedAccountStatus,
    isLoading: findAccountLoading,
    accountSummaryData,
    lockedAccountNumber,
  } = useSelector(({ accountSummary }) => accountSummary);
  const { advanceSearchData, isLoading } = useSelector(({ advanceSearch }) => advanceSearch);
  const { setPosition } = useContext(SelectTabContextProvider);
  const selectedRowAccNum = useRef(null);

  useEffect(() => {
    setPosition(-1);
  }, []);
  useEffect(() => {
    if (advanceSearchData?.resultObject?.length) {
      setSearchResults(advanceSearchData?.resultObject?.length);
    }
  }, [advanceSearchData]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [submit]);
  useEffect(() => {
    if (lockedAccountStatus === true || lockedAccountStatus === false) {
      setTimeout(() => {
        dispatch(resetLockAccountStatus());
      }, 7000);
    }

    if (lockedAccountStatus === false) {
      history.push({
        pathname: '/account-summary',
        state: {
          accountNumber:
            selectedRowAccNum?.current?.accountNumber || accountSummaryData?.accountNumber,
          fromWorkQueue: location?.state?.fromWorkQueue ? location.state.fromWorkQueue : '',
          workQueueName: location?.state?.workQueueName ? location.state.workQueueName : '',
          clientCode: selectedRowAccNum?.current?.clientCode || accountSummaryData?.clientNumber,
        },
      });
    }
  }, [lockedAccountStatus]);

  const convertToGMT = (date) => {
    return moment(date).utc().format('MM/DD/YYYY');
  };

  const lockUser = useSelector((state) => state?.accountSummary?.lockUser);
  const columns = [
    {
      title: 'Account Number',
      field: 'accountNumber',
      type: 'numeric',
      render: (rowData) => {
        return rowData && rowData.accountNumber ? (
          // <Link
          //   to={{
          //     pathname: `/account-summary`,
          //     state: {
          //       accountNumber: rowData?.accountNumber ? rowData.accountNumber : "",
          //       fromWorkQueue: location?.state?.fromWorkQueue ? location.state.fromWorkQueue : "",
          //       workQueueName: location?.state?.workQueueName ? location.state.workQueueName : "",
          //     },
          //   }}
          //   className={classes.link}
          // >
          //   {rowData.accountNumber}
          // </Link>
          <button
            style={{
              background: 'none',
              outline: 'none',
            }}
            onClick={() => {
              selectedRowAccNum.current = rowData?.accountNumber
                ? { accountNumber: rowData?.accountNumber, clientCode: rowData?.client }
                : '';
              dispatch(fetchAccountSummary(rowData?.accountNumber ? rowData.accountNumber : ''));
            }}
            className={classes.link}
          >
            {rowData.accountNumber}
          </button>
        ) : null;
      },
    },
    {
      title: 'Client Code',
      field: 'clientNumber',
    },
    {
      title: 'Client Account Number',
      field: 'clientReferenceNumber',
      type: 'numeric',
    },
    {
      title: 'SSN',
      field: 'socialSecurityNumber',
      minWidth: 130,
      type: 'numeric',
      render: (rowData) => {
        return rowData && rowData.socialSecurityNumber
          ? formatSsnNumber(rowData.socialSecurityNumber)
          : null;
      },
    },
    {
      title: 'Status',
      field: 'statusCode',
      type: 'numeric',
    },
    {
      title: 'Patient Name',
      field: 'patientName',
      minWidth: 220,
      type: 'string',
      render: (rowData) => {
        return rowData && rowData.patientName ? (
          <>
            <Avatar className="patient-avatar" name={rowData.patientName} size={33} round="5px" />
            <span className="patient-name">{rowData.patientName}</span>
          </>
        ) : null;
      },
    },
    {
      title: 'Phone Number',
      field: 'mobilePhone',
      type: 'numeric',
      minWidth: 180,
      render: (rowData) =>
        rowData['mobilePhone'] ? formatPhoneNumber(rowData['mobilePhone']) : '',
    },
    {
      title: 'Placement Date',
      field: 'placementDate',

      render: (rowData) => (rowData.placementDate ? convertToGMT(rowData.placementDate) : ''),
    },
    {
      title: 'City',
      field: 'city',
    },
    {
      title: 'State',
      field: 'state',
    },
    {
      title: 'Total Balance',
      field: 'accountBalance',
      type: 'numeric',
      numeric: true,
      render: (rowData) => {
        return rowData && rowData.accountBalance ? (
          <span className="total-balance">
            <NumberFormat
              value={rowData?.accountBalance}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              decimalScale={2}
              fixedDecimalScale
            />
          </span>
        ) : (
          <span className="total-balance">
            <NumberFormat
              value={0.0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              decimalScale={2}
              fixedDecimalScale
            />
          </span>
        );
      },
    },
  ];
  // if (searchData?.length === 1) {
  //   history.push({
  //     pathname: "/account-summary",
  //     state: { accountNumber: searchData[0].accountNumber },
  //   });
  // }

  return (
    <Grid item xs={12} className="accountsummry-tablescroll">
      <div className="dashboard-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          isLoading={loading}
          data={(query) =>
            new Promise((resolve) => {
              const url = `${ACCOUNTSUMMARY}/search/all`;
              const bodyObj = {
                accountNumber:
                  advancedSearchData?.accNumber && !clear
                    ? Number(advancedSearchData.accNumber)
                    : 0,
                clientNumber: advancedSearchData?.client && !clear ? advancedSearchData.client : '',
                clientReferenceNumber:
                  advancedSearchData?.clientAccNumber && !clear
                    ? advancedSearchData.clientAccNumber
                    : '',
                firstName:
                  advancedSearchData?.firstName && !clear ? advancedSearchData.firstName : '',
                lastName: advancedSearchData?.lastName && !clear ? advancedSearchData.lastName : '',
                placementDate:
                  advancedSearchData?.placementDate && !clear
                    ? convertToGMT(advancedSearchData.placementDate)
                    : '',
                mobileNumber:
                  advancedSearchData?.phone && !clear
                    ? advancedSearchData.phone
                      ?.trim()
                      .replace(/["()"]/g, '')
                      .replace(/\s/, '-')
                    : '',
                socialSecurityNumber:
                  advancedSearchData?.ssn && !clear
                    ? advancedSearchData.ssn.replace(/[^\d]/g, '')
                    : '',
                city: advancedSearchData?.city && !clear ? advancedSearchData.city : '',
                medicalRecordNumber:
                  advancedSearchData?.mrn && !clear ? advancedSearchData.mrn : '',
                state:
                  advancedSearchData.state && advancedSearchData.state.valueCode && !clear
                    ? advancedSearchData.state.valueCode
                    : '',
                limit: query.pageSize ? query.pageSize : null,
                search: query.search.trim(),
                page: submit
                  ? 1
                  : arrayLast && query.page >= 1
                    ? query.page
                    : arrayLast
                      ? (query.page <= 1 && query.page + 1) || query.page - 1
                      : query.page + 1,
                orderDirection: query.orderDirection,
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
              };
              setLoading(true);
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    resolve({
                      data: response.data.response.resultObject
                        ? response.data.response.resultObject
                        : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(response.data.response.resultObject.length === 1);
                    setSearchResults(
                      response?.data?.response?.count ? response.data.response.count : 0,
                    );
                    setSubmit(false);
                    setClear(false);
                    setLoading(false);
                    tableRef.current.dataManager['orderBy'] =
                      query?.orderBy?.tableData?.columnOrder;
                    tableRef.current.dataManager['orderDirection'] = query?.orderDirection;
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    setLoading(false);
                    setClear(false);
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            })
          }
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
          options={{
            pageSize: rows,
            toolbar: false,
            pageSizeOptions: tablePageRows,
            search: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                rowData.disposition && Number(rowData.disposition[0]) <= 5
                  ? colorCodes[Number(rowData.disposition[0]) - 1]
                  : '#ffff',
            }),
          }}
          onSelectionChange={(rows) => rows}
        />
      </div>
      {(isLoading || findAccountLoading) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {lockedAccountStatus && (
        <ErrorSnackbar
          errorMsg={`Account ${lockedAccountNumber} has been locked by ${lockUser}, please try again later.`}
        />
      )}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </Grid>
  );
}
